import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from './firebaseconfig';
import RobinhoodSpaceStatusBar from './components/RobinhoodSpaceStatusBar';
import GovOpsEntitlementBanner from './components/GovOpsEntitlementBanner';
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  Drawer,
  List,
  ListItem,
  Divider,
  Button,
  Box,
} from '@mui/material';

const drawerWidth = 240;

const outreachItems = [
  { label: 'Pilot demo', path: '/demo' },
  { label: 'Presenter deck', path: '/pilot-deck.html', external: true },
];

const navItems = [
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'View Map', path: '/map' },
  { label: 'Submit Permit', path: '/permit' },
  { label: 'Submit (address map)', path: '/permit/submit' },
  { label: 'Permit History', path: '/permit-history' },
  { label: 'All Permits', path: '/permit-list' },
  { label: 'User Settings', path: '/settings' },
  { label: 'Contact Support', path: '/contact-support' },
  { label: 'Sidewalk Ramp', path: '/sidewalk-ramp' },
];

const adminItems = [
  { label: 'Operations dashboard', path: '/admin' },
  { label: 'Manage permits', path: '/admin/table' },
  { label: 'Cases', path: '/admin/cases' },
];

const DashboardLayout = ({ children, email, isAdmin }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    if (!auth) {
      navigate('/');
      return;
    }
    signOut(auth)
      .then(() => navigate('/'))
      .catch((error) => console.error('Logout error:', error));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <RobinhoodSpaceStatusBar />
      <GovOpsEntitlementBanner />
      <AppBar position="static" elevation={1}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h6" noWrap component="span">
            RobinhoodSpace — False Alarm Permits
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ marginRight: 2 }}>
              Welcome{email ? `, ${email}` : ''}
            </Typography>
            <Button color="inherit" onClick={handleLogout}>
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: 'border-box',
              position: 'relative',
            },
          }}
        >
          <Divider />
          <List>
            {outreachItems.map((item) => (
              <ListItem key={item.path} disablePadding>
                <Button
                  component={item.external ? 'a' : Link}
                  href={item.external ? item.path : undefined}
                  to={item.external ? undefined : item.path}
                  target={item.external ? '_blank' : undefined}
                  rel={item.external ? 'noopener noreferrer' : undefined}
                  fullWidth
                  sx={{ justifyContent: 'flex-start', padding: '12px 16px' }}
                >
                  {item.label}
                </Button>
              </ListItem>
            ))}
            <Divider sx={{ my: 1 }} />
            {navItems.map((item) => (
              <ListItem key={item.path} disablePadding>
                <Button
                  component={Link}
                  to={item.path}
                  fullWidth
                  sx={{ justifyContent: 'flex-start', padding: '12px 16px' }}
                >
                  {item.label}
                </Button>
              </ListItem>
            ))}
            {isAdmin &&
              adminItems.map((item) => (
                <ListItem key={item.path} disablePadding>
                  <Button
                    component={Link}
                    to={item.path}
                    fullWidth
                    sx={{ justifyContent: 'flex-start', padding: '12px 16px' }}
                  >
                    {item.label}
                  </Button>
                </ListItem>
              ))}
          </List>
        </Drawer>

        <Box component="main" sx={{ flexGrow: 1, p: 3, minWidth: 0 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
